/* ==========================================================
   premium-collection-products.js  (v3 — new architecture)
   - Grid/List switch (localStorage)
   - AJAX native facet filtering + sorting (Section Rendering API)
   - CUSTOM price slider (pointer drag + keyboard, fully themable)
   - CLIENT-SIDE metaobject metafield filters (block-driven)
   - Quick Add popup (list "Add to Cart" for variant products)
   - Mini-cart open after add
   - Load-more / infinite scroll / popstate
   Delegated listeners = AJAX-safe.  Quick View handled by quick-view-v1.js.
========================================================== */
(function () {
  if (window.__pcpInit) return;
  window.__pcpInit = true;

  const VIEW_KEY = 'pcp-view';
  const section = () => document.querySelector('[data-pcp-section]');
  const money = (c) => { try { if (window.Shopify?.currency?.active) return new Intl.NumberFormat(undefined,{style:'currency',currency:Shopify.currency.active}).format(c/100);}catch(e){} return (c/100).toFixed(2); };

  /* ---------- cart ---------- */
  const openMiniCart = () => {
    try { if (window.Helm?.cart?.open) { window.Helm.cart.open(); return; } } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    const t = document.querySelector('[data-cart-drawer-toggle], #cart-icon-bubble, .js-drawer-open-cart');
    if (t) t.click();
  };
  const addToCart = async (id, quantity) => {
    if (window.Helm?.cart?.add) return window.Helm.cart.add(id, { quantity });
    const r = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id, quantity }) });
    if (!r.ok) throw new Error('add failed'); return r.json();
  };

  /* ---------- section rendering ---------- */
  const getSectionId = () => section()?.dataset.sectionId || null;
  const setBusy = (b) => { const r=document.querySelector('[data-results]'); if(r) r.setAttribute('aria-busy', b?'true':'false'); };
  const fetchSection = async (url) => {
    const id = getSectionId(); const u = new URL(url, location.origin);
    if (id) u.searchParams.set('section_id', id);
    const res = await fetch(u.toString(), { headers:{'X-Requested-With':'XMLHttpRequest'} });
    if (!res.ok) throw new Error('fetch '+res.status);
    return new DOMParser().parseFromString(await res.text(), 'text/html');
  };
  const applyRender = (doc, { append=false } = {}) => {
    // preserve client-side metaobject selections (native render replaces sidebar)
    const metaChecked = [...document.querySelectorAll('[data-meta-input]:checked')].map(i => i.dataset.metaKey + '::' + i.value);
    const nGrid=doc.querySelector('[data-grid]'), cGrid=document.querySelector('[data-grid]');
    const nList=doc.querySelector('[data-list]'), cList=document.querySelector('[data-list]');
    if (append && nGrid && cGrid) {
      cGrid.insertAdjacentHTML('beforeend', nGrid.innerHTML);
      if (nList && cList) cList.insertAdjacentHTML('beforeend', nList.innerHTML);
    } else {
      const nr=doc.querySelector('[data-results]'), cr=document.querySelector('[data-results]');
      if (nr && cr) cr.innerHTML = nr.innerHTML;
      const ns=doc.querySelector('[data-sidebar]'), cs=document.querySelector('[data-sidebar]');
      if (ns && cs) cs.innerHTML = ns.innerHTML;
    }
    const np=doc.querySelector('[data-pagination]'), cp=document.querySelector('[data-pagination]');
    if (cp) { if (np) cp.replaceWith(np); else cp.remove(); }
    else if (np && !append) document.querySelector('.pcp__main')?.appendChild(np);
    const nc=doc.querySelector('[data-product-count]'), cc=document.querySelector('[data-product-count]');
    if (nc && cc) cc.textContent = nc.textContent;
    // restore metaobject selections
    if (metaChecked.length) document.querySelectorAll('[data-meta-input]').forEach(i => { if (metaChecked.includes(i.dataset.metaKey + '::' + i.value)) i.checked = true; });
    initSliders(); setupMetaUI(); applyMetaFilters(); applyView(getView(), false);
    if (!append) hydrateFullCounts();
  };
  const navigate = async (url, { push=true, append=false } = {}) => {
    try { setBusy(true); const doc=await fetchSection(url); applyRender(doc,{append});
      if (push) history.pushState({pcp:true}, '', url);
      if (!append){ const t=section(); if(t) window.scrollTo({top:t.getBoundingClientRect().top+scrollY-20, behavior:'smooth'}); }
    } catch(e){ console.error('[PCP]',e); if(push) location.href=url; } finally { setBusy(false); }
  };

  /* ---------- view ---------- */
  const getView = () => localStorage.getItem(VIEW_KEY) || section()?.dataset.defaultView || 'grid';
  const applyView = (view, persist=true) => {
    document.querySelector('.pcp__layout')?.setAttribute('data-view', view);
    document.querySelectorAll('.pcp-view__btn').forEach(b=>{ const a=b.dataset.view===view; b.classList.toggle('is-active',a); b.setAttribute('aria-pressed',String(a)); });
    if (persist) localStorage.setItem(VIEW_KEY, view);
  };

  /* ---------- CUSTOM PRICE SLIDER ---------- */
  const initSliders = () => {
    document.querySelectorAll('[data-price-filter]').forEach((wrap) => {
      if (wrap.__init) return; wrap.__init = true;
      const range = wrap.querySelector('[data-range]');
      const fill = wrap.querySelector('[data-range-fill]');
      const gMin = wrap.querySelector('[data-grip="min"]');
      const gMax = wrap.querySelector('[data-grip="max"]');
      const iMin = wrap.querySelector('[data-price-min]');
      const iMax = wrap.querySelector('[data-price-max]');
      if (!range || !gMin || !gMax) return;
      const min = parseFloat(wrap.dataset.rangeMin || '0');
      const max = parseFloat(wrap.dataset.rangeMax || '0') || 1;
      let lo = iMin && iMin.value !== '' ? parseFloat(iMin.value) : min;
      let hi = iMax && iMax.value !== '' ? parseFloat(iMax.value) : max;

      const pct = (v) => ((v - min) / (max - min)) * 100;
      const paint = () => {
        const a = pct(lo), b = pct(hi);
        gMin.style.left = a + '%'; gMax.style.left = b + '%';
        fill.style.left = a + '%'; fill.style.right = (100 - b) + '%';
        gMin.setAttribute('aria-valuenow', Math.round(lo));
        gMax.setAttribute('aria-valuenow', Math.round(hi));
      };
      const syncInputs = () => { if (iMin) iMin.value = Math.round(lo) === Math.round(min) ? '' : Math.round(lo); if (iMax) iMax.value = Math.round(hi) === Math.round(max) ? '' : Math.round(hi); };
      const valueFromX = (clientX) => {
        const r = range.getBoundingClientRect();
        let p = (clientX - r.left) / r.width; p = Math.min(1, Math.max(0, p));
        return min + p * (max - min);
      };
      const drag = (grip, which) => (e) => {
        e.preventDefault(); grip.setPointerCapture?.(e.pointerId);
        const move = (ev) => {
          const v = valueFromX(ev.clientX);
          if (which === 'min') lo = Math.min(v, hi); else hi = Math.max(v, lo);
          paint(); syncInputs();
        };
        const up = () => { grip.removeEventListener('pointermove', move); grip.removeEventListener('pointerup', up); submitFilters(); };
        grip.addEventListener('pointermove', move); grip.addEventListener('pointerup', up);
      };
      gMin.addEventListener('pointerdown', drag(gMin, 'min'));
      gMax.addEventListener('pointerdown', drag(gMax, 'max'));
      const step = Math.max(1, Math.round((max - min) / 100));
      const key = (which) => (e) => {
        let d = 0; if (e.key==='ArrowRight'||e.key==='ArrowUp') d=step; if (e.key==='ArrowLeft'||e.key==='ArrowDown') d=-step;
        if (!d) return; e.preventDefault();
        if (which==='min') lo = Math.max(min, Math.min(lo+d, hi)); else hi = Math.min(max, Math.max(hi+d, lo));
        paint(); syncInputs(); clearTimeout(wrap.__kt); wrap.__kt=setTimeout(submitFilters, 500);
      };
      gMin.addEventListener('keydown', key('min')); gMax.addEventListener('keydown', key('max'));
      const onType = () => { lo = iMin.value!==''?parseFloat(iMin.value):min; hi = iMax.value!==''?parseFloat(iMax.value):max; if(lo>hi)[lo,hi]=[hi,lo]; paint(); };
      iMin?.addEventListener('input', onType); iMax?.addEventListener('input', onType);
      iMin?.addEventListener('change', submitFilters); iMax?.addEventListener('change', submitFilters);
      paint();
    });
  };

  /* ---------- native facet submit ---------- */
  const isMobile = () => window.matchMedia('(max-width: 989px)').matches;
  const submitFilters = () => {
    const form = document.querySelector('[data-filter-form]'); if (!form) return;
    const params = new URLSearchParams();
    for (const [k,v] of new FormData(form).entries()) if (v!=='' && v!=null) params.append(k,v);
    const base = form.getAttribute('action') || location.pathname;
    navigate(params.toString() ? `${base}?${params}` : base);
  };

  /* ---------- CLIENT-SIDE METAOBJECT FILTERS ---------- */
  const parseCardMf = (card) => {
    const map = {};
    (card.getAttribute('data-mf') || '').split(';').forEach(pair => {
      if (!pair) return; const i = pair.indexOf(':'); if (i<0) return;
      const key = pair.slice(0,i); const handles = pair.slice(i+1).trim().split(/\s+/).filter(Boolean);
      map[key] = new Set(handles);
    });
    return map;
  };
  const collectMeta = () => {
    const groups = {};
    document.querySelectorAll('[data-meta-input]:checked').forEach(inp => {
      const key = inp.dataset.metaKey;
      const grp = inp.closest('[data-meta-group]');
      const logic = grp?.dataset.logic || 'any';
      (groups[key] ||= { logic, values: new Set() }).values.add(inp.value);
    });
    return groups;
  };
  const cardMatchesGroups = (card, groups) => {
    const map = parseCardMf(card);
    return Object.entries(groups).every(([key, g]) => {
      const have = map[key] || new Set(); const sel = [...g.values];
      return g.logic === 'all' ? sel.every(h => have.has(h)) : sel.some(h => have.has(h));
    });
  };
  const applyMetaFilters = () => {
    const groups = collectMeta(); const active = Object.keys(groups).length > 0;
    document.querySelectorAll('[data-product-card]').forEach(card => {
      card.hidden = active && !cardMatchesGroups(card, groups);
    });
    const grid = document.querySelector('[data-grid]');
    if (grid) {
      const anyVisible = [...grid.querySelectorAll('[data-product-card]')].some(c => !c.hidden);
      let note = grid.querySelector('[data-meta-empty]');
      if (active && !anyVisible) { if (!note) { note = document.createElement('p'); note.className='pcp-empty'; note.setAttribute('data-meta-empty',''); note.textContent='No products match these filters.'; grid.appendChild(note); } }
      else if (note) note.remove();
    }
    renderChips(groups);
    // NOTE: product counts are authoritative from Liquid (server-side, whole collection)
    // and re-rendered on every AJAX facet change. We intentionally do NOT recompute them
    // from the rendered DOM here, which previously collapsed accurate counts to 0.
  };

  /* active-filter chips above the grid */
  const renderChips = (groups) => {
    const bar = document.querySelector('[data-active-chips]'); if (!bar) return;
    const checked = [...document.querySelectorAll('[data-meta-input]:checked')];
    if (!checked.length) { bar.hidden = true; bar.innerHTML = ''; return; }
    bar.hidden = false;
    bar.innerHTML = checked.map(i => `<button type="button" class="pcp-chip" data-chip-remove data-key="${i.dataset.metaKey}" data-value="${i.value}">${(i.dataset.label||i.value)} <span class="pcp-chip__x" aria-hidden="true">&times;</span></button>`).join('')
      + `<button type="button" class="pcp-chip pcp-chip--clear" data-chip-clear>Clear all</button>`;
  };

  /* FULL-COLLECTION COUNTS: aggregate every product's data-mf across all pages
     (works past Liquid's 50-product cap and without native facets). */
  let countsHydrated = false;
  const hydrateFullCounts = async () => {
    const groups = document.querySelectorAll('[data-meta-group]');
    if (!groups.length) return;
    const counts = {}; const seen = new Set();
    const tally = (cards) => cards.forEach(card => {
      const h = card.dataset.productHandle; if (!h || seen.has(h)) return; seen.add(h);
      const map = parseCardMf(card);
      for (const key in map) { counts[key] = counts[key] || {}; map[key].forEach(x => { counts[key][x] = (counts[key][x] || 0) + 1; }); }
    });
    // page 1 is already in the DOM
    tally([...document.querySelectorAll('[data-grid] [data-product-card]')]);
    // carry any active native facet params, walk the remaining pages
    const base = section()?.dataset.collectionUrl || location.pathname;
    const active = new URLSearchParams(location.search); active.delete('page');
    for (let p = 2; p <= 50; p++) {
      const u = new URL(base, location.origin);
      active.forEach((val, k) => u.searchParams.append(k, val));
      u.searchParams.set('page', p);
      let doc; try { doc = await fetchSection(u.pathname + u.search); } catch (e) { break; }
      const cards = [...doc.querySelectorAll('[data-grid] [data-product-card]')];
      if (!cards.length) break;
      tally(cards);
    }
    // write aggregated counts back
    groups.forEach(g => {
      const key = g.dataset.metaKey; const c = counts[key] || {};
      g.querySelectorAll('.pcp-opt').forEach(opt => {
        const input = opt.querySelector('[data-meta-input]'); const el = opt.querySelector('[data-count-el]');
        if (el && input) el.textContent = c[input.value] || 0;
      });
    });
    countsHydrated = true;
  };

  /* group search + view-more */
  const setupMetaUI = () => {
    document.querySelectorAll('[data-meta-search]').forEach(inp => {
      if (inp.__b) return; inp.__b = true;
      inp.addEventListener('input', () => {
        const q = inp.value.trim().toLowerCase();
        inp.closest('.pcp-group__body').querySelectorAll('.pcp-opt').forEach(o => {
          const t = (o.querySelector('.pcp-opt__label')?.textContent || '').toLowerCase();
          o.closest('.pcp-list__item').classList.toggle('pcp-opt-hidden', q && !t.includes(q));
        });
      });
    });
    document.querySelectorAll('[data-meta-group][data-max-visible]').forEach(ul => {
      if (ul.__b) return; ul.__b = true;
      const max = parseInt(ul.dataset.maxVisible, 10) || 0;
      const items = [...ul.querySelectorAll('.pcp-list__item')];
      if (max > 0 && items.length > max) {
        items.slice(max).forEach(i => i.classList.add('pcp-opt-hidden'));
        const more = ul.parentElement.querySelector('[data-meta-more]');
        if (more) { more.hidden = false; more.addEventListener('click', () => { items.forEach(i => i.classList.remove('pcp-opt-hidden')); more.hidden = true; }); }
      }
    });
  };

  /* ---------- Quick Add popup (list add-to-cart, variant products) ---------- */
  const qaOverlay = () => document.querySelector('[data-quick-add-popup]');
  let qaState = { product:null, selected:{}, variant:null };
  const qaClose = () => { const o=qaOverlay(); if(o){ o.classList.remove('is-open'); o.setAttribute('aria-hidden','true'); } };
  const qaFindVariant = () => { const p=qaState.product; if(!p) return null; return p.variants.find(v => (p.options||[]).every((opt,i)=> v['option'+(i+1)]===qaState.selected[opt])) || null; };
  const qaRender = () => {
    const o=qaOverlay(); if(!o) return; const v=qaFindVariant(); qaState.variant=v;
    const price=o.querySelector('.qa-price'), add=o.querySelector('[data-qa-add]'), img=o.querySelector('.qa-image');
    if (v) { if(price) price.textContent=money(v.price); if(v.featured_image?.src&&img) img.src=v.featured_image.src; if(add){ add.disabled=!v.available; add.querySelector('.qa-add__label').textContent=v.available?'Add to Cart':'Sold Out'; } }
    else if (add) add.disabled=true;
    o.querySelectorAll('.qa-optval').forEach(b=> b.classList.toggle('is-active', qaState.selected[b.dataset.option]===b.dataset.value));
  };
  const qaOpen = async (handle) => {
    const o=qaOverlay(); if(!o) return; const err=o.querySelector('[data-qa-error]'); if(err) err.hidden=true;
    try {
      const res=await fetch(`/products/${handle}.js`); if(!res.ok) throw 0; const p=await res.json();
      qaState={ product:p, selected:{}, variant:null };
      (p.options||[]).forEach((opt,i)=> qaState.selected[opt]=(p.variants[0]||{})['option'+(i+1)]);
      o.querySelector('.qa-title').textContent=p.title;
      o.querySelector('.qa-image').src=(p.featured_image||p.images?.[0]||''); o.querySelector('.qa-image').alt=p.title;
      const wrap=o.querySelector('[data-qa-options]'); wrap.innerHTML='';
      const single = p.options?.length===1 && p.options[0]==='Title' && p.variants.length===1;
      if (!single) (p.options||[]).forEach(opt=>{
        const vals=[...new Set(p.variants.map(v=>v.options[p.options.indexOf(opt)]))];
        const g=document.createElement('div'); g.className='qa-optgroup'; g.innerHTML=`<div class="qa-optgroup__label">${opt}</div>`;
        const box=document.createElement('div'); box.className='qa-optvals';
        vals.forEach(val=>{ const b=document.createElement('button'); b.type='button'; b.className='qa-optval'; b.dataset.option=opt; b.dataset.value=val; b.textContent=val; box.appendChild(b); });
        g.appendChild(box); wrap.appendChild(g);
      });
      o.querySelector('.qa-qty-input').value=1; qaRender();
      o.classList.add('is-open'); o.setAttribute('aria-hidden','false'); o.querySelector('.qa-modal')?.focus();
    } catch(e){ console.error('[PCP] qa', e); }
  };

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', async (e) => {
    const vb=e.target.closest('.pcp-view__btn'); if(vb){ applyView(vb.dataset.view); return; }
    const chipRm=e.target.closest('[data-chip-remove]');
    if (chipRm) { const inp=document.querySelector(`[data-meta-input][data-meta-key="${chipRm.dataset.key}"][value="${chipRm.dataset.value}"]`); if(inp){ inp.checked=false; applyMetaFilters(); } return; }
    if (e.target.closest('[data-chip-clear]')) { document.querySelectorAll('[data-meta-input]:checked').forEach(i=>i.checked=false); applyMetaFilters(); return; }
    if (e.target.closest('[data-filter-open]')) { section()?.classList.add('is-filter-open'); const ov=document.querySelector('[data-filter-overlay]'); if(ov) ov.hidden=false; document.querySelector('[data-filter-open]')?.setAttribute('aria-expanded','true'); return; }
    if (e.target.closest('[data-filter-close]') || e.target.closest('[data-filter-overlay]')) { section()?.classList.remove('is-filter-open'); const ov=document.querySelector('[data-filter-overlay]'); if(ov) ov.hidden=true; document.querySelector('[data-filter-open]')?.setAttribute('aria-expanded','false'); return; }
    if (e.target.closest('[data-filter-apply]')) { e.preventDefault(); submitFilters(); section()?.classList.remove('is-filter-open'); const ov=document.querySelector('[data-filter-overlay]'); if(ov) ov.hidden=true; return; }
    const rm=e.target.closest('[data-filter-remove], [data-clear-all]'); if(rm && rm.tagName==='A'){ e.preventDefault(); navigate(rm.getAttribute('href')); return; }
    const more=e.target.closest('[data-load-more]'); if(more){ e.preventDefault(); more.textContent='…'; navigate(more.dataset.nextUrl,{push:false,append:true}); return; }
    const pg=e.target.closest('.pcp-pagenav__link[href]'); if(pg){ e.preventDefault(); navigate(pg.getAttribute('href')); return; }

    // list "Add to Cart" for variant products
    const trig=e.target.closest('[data-quick-add-trigger]');
    if (trig) { e.preventDefault(); if(trig.dataset.available==='false') return;
      if (trig.dataset.hasVariants==='true'){ qaOpen(trig.dataset.product); return; }
      try { await addToCart(trig.dataset.variantId,1); openMiniCart(); } catch(err){ console.error(err); } return; }

    // quick add popup interactions
    if (e.target.closest('[data-qa-close]') || e.target===qaOverlay()){ qaClose(); return; }
    const opt=e.target.closest('.qa-optval'); if(opt){ qaState.selected[opt.dataset.option]=opt.dataset.value; qaRender(); return; }
    if (e.target.closest('.qa-plus')){ const i=qaOverlay().querySelector('.qa-qty-input'); i.value=(+i.value||1)+1; return; }
    if (e.target.closest('.qa-minus')){ const i=qaOverlay().querySelector('.qa-qty-input'); i.value=Math.max(1,(+i.value||1)-1); return; }
    const add=e.target.closest('[data-qa-add]');
    if (add){ const o=qaOverlay(); const err=o.querySelector('[data-qa-error]');
      if(!qaState.variant){ if(err){err.hidden=false; err.textContent='Please select options.';} return; }
      const qty=+o.querySelector('.qa-qty-input').value||1; add.classList.add('is-loading'); add.disabled=true; if(err) err.hidden=true;
      try { await addToCart(qaState.variant.id, qty); add.classList.remove('is-loading'); add.querySelector('.qa-add__label').textContent='Added ✓'; openMiniCart();
        setTimeout(()=>{ qaClose(); add.disabled=false; add.querySelector('.qa-add__label').textContent='Add to Cart'; }, 900);
      } catch(e2){ add.classList.remove('is-loading'); add.disabled=false; if(err){err.hidden=false; err.textContent='Could not add to cart.';} }
      return; }
  });

  /* ---------- change / keydown ---------- */
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-meta-input]')) { applyMetaFilters(); return; }
    if (e.target.matches('[data-filter-input]')) { if(!isMobile()) submitFilters(); return; }
    if (e.target.matches('[data-sort-select]')) {
      document.querySelectorAll('[data-sort-select]').forEach(s=>{ s.value=e.target.value; });
      const url=new URL(location.href); url.searchParams.set('sort_by', e.target.value); navigate(url.pathname+url.search); return;
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key==='Escape'){ if(qaOverlay()?.classList.contains('is-open')){ qaClose(); return; } const el=section(); if(el?.classList.contains('is-filter-open')){ el.classList.remove('is-filter-open'); const ov=document.querySelector('[data-filter-overlay]'); if(ov) ov.hidden=true; } }
  });

  /* ---------- list quick-add form (single variant) ---------- */
  document.addEventListener('submit', async (e) => {
    const form=e.target.closest('[data-quick-add]'); if(!form) return; e.preventDefault();
    const btn=form.querySelector('button[type="submit"]'); const orig=btn?btn.textContent:'';
    if(btn){ btn.disabled=true; btn.textContent='…'; }
    try { await addToCart(form.querySelector('input[name="id"]').value,1); openMiniCart(); if(btn) btn.textContent='✓'; setTimeout(()=>{ if(btn){btn.textContent=orig; btn.disabled=false;} },1200); }
    catch(err){ if(btn){ btn.textContent=orig; btn.disabled=false; } }
  });

  /* ---------- infinite scroll ---------- */
  let io=null;
  const setupInfinite = () => {
    const el=section(); if(!el || el.dataset.paginationMode!=='infinite') return;
    if(io) io.disconnect();
    io=new IntersectionObserver(es=>es.forEach(en=>{ if(!en.isIntersecting) return; const b=document.querySelector('[data-load-more]'); if(b){ io.unobserve(en.target); navigate(b.dataset.nextUrl,{push:false,append:true}).then(setupInfinite);} }),{rootMargin:'600px'});
    const s=document.querySelector('[data-load-more]'); if(s) io.observe(s);
  };

  window.addEventListener('popstate', () => navigate(location.pathname+location.search,{push:false}));
  const boot = () => { if(!section()) return; applyView(getView(),false); initSliders(); setupMetaUI(); applyMetaFilters(); setupInfinite(); hydrateFullCounts(); };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
